var Primary = require('Decorators').Primary;

var UserSession = function () {

    this.GalleryKey   = Primary(String)
    this.UserName     = String;
    this.SessionToken = String;
    this.CreatedOn    = String;
    this.ExpiresOn    = String;
    this.RenewableOn  = String;

}

module.exports = UserSession;